import apiHandler from "../core/apiHandler";

const purchaseButtonActionApi = apiHandler('purchases/history-actions');
export default purchaseButtonActionApi;